<template>
  <v-data-table
    :headers="headers"
    :items="value"
    :items-per-page="15"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
  />
</template>

<script>
import Helpers from 'src/utils/helpers'

export default {
  name: 'PlayerList',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('player.fields.session.name'),
          value: 'sessionName',
        },
        {
          text: this.$t('player.fields.session.dateCreate'),
          value: 'dateCreate',
        },
        {
          text: this.$t('general.language'),
          value: 'lang',
          align: 'center',
          width: '15%',
        },
        {
          text: this.$t('player.fields.player.name'),
          value: 'playerName',
          align: 'center',
          sortable: true,
        },
        {
          text: this.$t('player.fields.player.email'),
          value: 'playerEmail',
          align: 'center',
          sortable: true,
        },
      ]
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>
